import { GridCellProps } from "@progress/kendo-react-grid";

export const DefaultLoadingTimeGridCell = ({ dataItem, field, columnIndex }: GridCellProps) => {
  return field ? (
    <td colSpan={1} role="gridcell" aria-colindex={columnIndex} data-grid-col-index={columnIndex}>
      {dataItem.DefaultLoadingTimeAsString}
    </td>
  ) : (
    <td />
  );
};
